<template>
    <div class="form-item">
        <div class="form-label">
            <label v-if="label != null">{{ label }}</label>
        </div>
        <div class="form-value">
            <el-input :disabled="disabled" size="small" v-model="curValue" clearable @change="syncModel" @keyup.native.stop="doKeyEvnt($event)" @clear="doClear"></el-input>
        </div>
    </div>
</template>

<script>
    // last modified by koqiui
    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'

    //有效的值类型
    let validValueTypes = ['String'];

    function isValidValueType(valueType) {
        return validValueTypes.indexOf(valueType) != -1;
    }

    //
    export default {
        name: 'swb-query-text-field',
        //
        props: {
            valueType: {
                type: String,
                default: 'String'
            },
            label: {
                type: String,
                default: null
            },
            disabled: {
                type: Boolean,
                default: false
            },
            placeholder: {
                type: String,
                default: null
            },
            iniValue: {
                type: String,
                default: null
            }
        },
        //
        data() {
            return {
                curValue: null,
                //
                theTimer: null
            };
        },
        watch: {
            valueType(newVal, oldVal) {
                this.init();
            },
            iniValue(newVal, oldVal) {
                this.init();
            }
        },
        //
        created() {
            this.init();
        },
        destroyed() {
            clearTimeout(this.theTimer);
        },
        //
        methods: {
            init() {
                if(!isValidValueType(this.valueType)) {
                    let message = '组件的值类型有误，可用的值类型为：' + validValueTypes.join(", ");
                    if(typeof Toast !== 'undefined') {
                        Toast.show(message, 3000, 'error');
                    }
                    else {
                        MsgBox.error(message);
                    }
                }
                //
                clearTimeout(this.theTimer);
                //初始化
                this.curValue = this.iniValue;
                this.syncModel();
            },
            doClear: function () {
                clearTimeout(this.theTimer);
                //
                this.curValue = null;
                //
                this.syncModel();
            },
            syncModel() {
                this.theTimer = setTimeout(this.syncModelInner, 50);
            },
            syncModelInner() {
                let resultValue = this.curValue;
                if(resultValue != null) {
                    resultValue = this.curValue = resultValue.trim();
                }
                //
                this.$emit('input', resultValue);
            },
            //
            doKeyEvnt(evnt) {
                evnt = evnt || {};
                if(evnt.code == 'Enter') {
                    this.$emit('Enter', this.label);
                }
            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/compo/query/QueryTextField.vue